/* eslint-disable */
import React  from "react"
import ls from "local-storage"
import { useHistory } from "react-router-dom"

export default function LogOut() {
    let history = useHistory();
  React.useEffect(()=>{
    ls.set("currentcustomer", "");
    ls.set("currentcustomerUid","");
    history.push("/")
  },[])
    return (
        <></>
    )
}

